const ROAST_STEPS = [
  { match: /light/i, color: '#ffda6c' },
  { match: /medium/i, color: '#fa9950' },
  { match: /dark/i, color: '#ff5131' },
];

function colorForOption(option) {
  const step = ROAST_STEPS.find((candidate) => candidate.match.test(option.textContent));
  return step ? step.color : '#cccccc';
}

function buildRoastOptions(wrapper) {
  const select = wrapper.querySelector('select');
  if (!select || wrapper.dataset.roastInit) return;

  const options = Array.from(select.options).filter((option) => option.value !== '');
  if (options.length < 2) return;

  wrapper.dataset.roastInit = 'true';

  const fieldBox = select.closest('.globo-form-input') || select.parentElement;
  fieldBox.classList.add('visually-hidden-input');

  const optionList = document.createElement('div');
  optionList.className = 'roast-type__options';

  const buttons = options.map((option, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'roast-type__option';
    button.style.setProperty('--roast-option-color', colorForOption(option));
    button.setAttribute('aria-pressed', 'false');
    button.textContent = `${'🔥'.repeat(index + 1)} ${option.textContent}`;

    button.addEventListener('click', () => {
      if (select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        setSelected(option.value);
      }
    });

    optionList.appendChild(button);
    return button;
  });

  const setSelected = (value) => {
    buttons.forEach((button, index) => {
      const isSelected = options[index].value === value;
      button.classList.toggle('roast-type__option--selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
    });
  };

  fieldBox.insertAdjacentElement('afterend', optionList);

  select.addEventListener('change', () => setSelected(select.value));

  setSelected(select.value || options[0].value);
}

function buildRoastTopicPills(wrapper) {
  if (wrapper.dataset.roastTopicsInit) return;

  const checkboxes = Array.from(wrapper.querySelectorAll('input[type="checkbox"]'));
  if (!checkboxes.length) return;

  wrapper.dataset.roastTopicsInit = 'true';

  checkboxes.forEach((checkbox) => {
    checkbox.classList.add('visually-hidden-input');

    const pill = checkbox.closest('label')
      || (checkbox.id && wrapper.querySelector(`label[for="${checkbox.id}"]`))
      || checkbox.parentElement;

    const syncSelected = () => pill.classList.toggle('roast-topic--selected', checkbox.checked);

    checkbox.addEventListener('change', syncSelected);
    syncSelected();
  });
}

function scanForRoastFields(root) {
  root.querySelectorAll('.roast-type').forEach(buildRoastOptions);
  root.querySelectorAll('.globo-form-control[data-type="checkbox"]').forEach(buildRoastTopicPills);
}

scanForRoastFields(document);

const roastFieldsObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('.roast-type')) buildRoastOptions(node);
      if (node.matches('.globo-form-control[data-type="checkbox"]')) buildRoastTopicPills(node);
      scanForRoastFields(node);
    }
  }
});

roastFieldsObserver.observe(document.body, { childList: true, subtree: true });
